export const API_BASE='https://api.heptadecane.xyz'
export const GOOGLE_MAPS_API_KEY='AIzaSyDJII9QOtyX1R5XzxDHliSHvBdyi0jGY5c'